import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import NotCertifiableAnprList from 'shell/components/shared/not-certifiable-anpr-list';
import { AccordionSubjectAttributesVM } from 'shell/components/shared/sipo-person-form/new-person';
import { memo } from 'react';

interface SubjectAttributesFormProps {
  values?: AccordionSubjectAttributesVM;
  onChange: (
    key: keyof AccordionSubjectAttributesVM,
    value: AccordionSubjectAttributesVM[keyof AccordionSubjectAttributesVM]
  ) => void;
  disabled?: boolean;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionSubjectAttributesVM>;
  touched?: FormikTouched<AccordionSubjectAttributesVM>;
}

const SubjectAttributesFormComponent = ({
  values,
  onChange,
  disabled,
  isEditMode,
  errors,
  touched,
}: SubjectAttributesFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="homeless"
              checked={values?.homeless || false}
              onChange={() => onChange('homeless', !values?.homeless)}
              inputProps={{ 'aria-label': 'senza fissa dimora' }}
              disabled={isEditMode ? false : disabled}
            />
          }
          label="Senza fissa dimora"
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <NotCertifiableAnprList
          aria-label="Soggetto certificabile"
          label="Soggetto certificabile"
          id="subjectCertifiable"
          value={values?.subject || ''}
          onChange={(value) => onChange('subject', value)}
          disabled={isEditMode ? false : disabled}
          error={touched?.subject && Boolean(errors?.subject)}
        />
      </Grid>
    </Grid>
  );
};

SubjectAttributesFormComponent.displayName = 'Subject Attributes component';

const SubjectAttributesForm = memo(SubjectAttributesFormComponent);

export default SubjectAttributesForm;
